import React from "react";
import "./Modal.css";
import Modal from "react-bootstrap/Modal";
const Modals = (props) => {
  const handleClose = () => {
    props.setshow(false);
  };
  return (
    <>
      <Modal className="Test1" show={props.Show} onHide={handleClose}>
        <Modal.Body>
          <div className="Test1wrapper">
            <span className="Test1heading">
              The bounty will now move to "Accepted".Are you sure to do this?
            </span>
            <div className="Test1Input mt-5">
              <button className="Testbtn me-5">Yes</button>
              <button className="Testbtn Actives">No</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Modals;
